import { ListFieldPicklist } from "../queries/getCrmListFieldDefinitions";
import { FormPicklist } from "../schemas/DemoTypes";
export function getPicklistOptions(picklist: ListFieldPicklist): FormPicklist {
  if (picklist.length === 0) return [];
  return picklist.flatMap((item) => {
    if ("options" in item) {
      return [
        ...[
          {
            key: item.label,
            value: item.label,
            text: <strong>{item.label}</strong>,
            header: true,
            disabled: true,
            className: "tw-opacity-100",
          },
        ],
        ...item.options.map((option) => ({
          key: String(option.value),
          value: String(option.value),
          text: option.label,
        })),
      ];
    }
    return {
      key: String(item.value),
      value: String(item.value),
      text: item.label,
    };
  });
}
